/**
 * Multi checkbox
 * 
 * @param {NodeList} eles
 * @param {object} opts
 * @returns {null}
 */
const multiCheckboxInput = (eles, opts = {}) => {
  const {
    initialValue,
    onChange: onChangeCb
  } = opts;

  if (!eles || !eles.length) return;
  const name = eles[0].name;

  const getValues = () => {
    let values = [];

    eles.forEach(({checked, value}) => {
      if (checked) values.push(value);
    });

    return values;
  }

  const onChange = () => {
    const value = getValues();

    onChangeCb && onChangeCb({name, value});
  }

  const init = () => {
    const values = initialValue || [];

    eles.forEach(ele => {
      ele.checked = values.includes(ele.value);
      ele.addEventListener('change', onChange);
    });
  }

  init();
}

export default multiCheckboxInput;